export const humanizeCount = (num) => {
  if (!num) {
    return num;
  }

  if (num < 0) {
    const tempNum = Math.abs(num);
    if (tempNum < 1000) {
      return `-${tempNum}`;
    }
    if (tempNum < 1000_000) {
      return `-${(tempNum / 1000).toFixed(1)}K`;
    }
    if (tempNum < 1000_000_000) {
      return `-${(tempNum / 1000_000).toFixed(1)}M`;
    }
    if (tempNum < 1000_000_000_000) {
      return `-${(tempNum / 1000_000_000).toFixed(1)}B`;
    }

    return `-${(tempNum / 1000_000_000_000).toFixed(1)}T`;
  }

  if (num < 1000) {
    return num;
  }
  if (num < 1000_000) {
    return `${(num / 1000).toFixed(1)}K`;
  }
  if (num < 1000_000_000) {
    return `${(num / 1000_000).toFixed(1)}M`;
  }
  if (num < 1000_000_000_000) {
    return `${(num / 1000_000_000).toFixed(1)}B`;
  }

  return `${(num / 1000_000_000_000).toFixed(1)}T`;
};

export const humanizeCountToFloor = (num) => {
  if (!num) {
    return num;
  }
  if (num < 0) {
    const tempNum = Math.abs(num);
    if (tempNum < 1000) {
      return `-${tempNum}`;
    }
    if (tempNum < 1000_000) {
      return `-${Math.floor(tempNum / 1000)}K+`;
    }
    if (tempNum < 1000_000_000) {
      return `-${Math.floor(tempNum / 1000_000)}M+`;
    }
    if (tempNum < 1000_000_000_000) {
      return `-${Math.floor(tempNum / 1000_000_000)}B+`;
    }

    return `-${Math.floor(tempNum / 1000_000_000_000)}T+`;
  }

  if (num < 1000) {
    return num;
  }
  if (num < 1000_000) {
    return `-${Math.floor(num / 1000)}K+`;
  }
  if (num < 1000_000_000) {
    return `-${Math.floor(num / 1000_000)}M+`;
  }
  if (num < 1000_000_000_000) {
    return `-${Math.floor(num / 1000_000_000)}B+`;
  }

  return `-${Math.floor(num / 1000_000_000_000)}T+`;
};
